var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._b({ref:_vm.refid,tag:"component",attrs:{"value":_vm.value},on:{"input":_vm.handleComponentInput}},'component',_vm.props,false))}
var staticRenderFns = []

export { render, staticRenderFns }